export const types = {
  SET_DASHBOARD_LOCATIONS: 'SET_DASHBOARD_LOCATIONS',
  SET_DASHBOARD_PROFILE_NAMES: 'SET_DASHBOARD_PROFILE_NAMES',
};
